module.exports = __webpack_public_path__ + "media/images/members/maria_jose_caamano-f5d472bf2edf36b1961f8862d61df9e7.jpg";